var _defs, _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReadoutTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 412.38,
    height: 292.49,
    viewBox: "0 0 412.38 292.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b8b43;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.18,218.64a83.16,83.16,0,0,1,.9-12.15H37.27a12,12,0,0,1-12-12V36.28a12,12,0,0,1,12-12H338.75a12,12,0,0,1,12,12V115a16.25,16.25,0,0,1,13.74,24.43,81.28,81.28,0,0,1,12,5V22.55A22.55,22.55,0,0,0,353.92,0H22.58A22.55,22.55,0,0,0,0,22.55L0,208.43A22.56,22.56,0,0,0,22.55,231H75.24v35.4a6.59,6.59,0,0,0,6.59,6.6H275.42A83,83,0,0,1,255.18,218.64Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.2,145.1V138h5.27a6.77,6.77,0,0,0,0-13.53H326.4a6.77,6.77,0,1,0,0,13.53h5.27v7.1a73.84,73.84,0,1,0,13.53,0Zm-6.67,131.5a58,58,0,1,1,0-115.92h0a58,58,0,1,1,0,115.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.52,168.37a7.56,7.56,0,0,0,10.67,0h0a7.56,7.56,0,0,0,0-10.66l-7.66-7.65a7.54,7.54,0,1,0-10.66,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341,168.4a2.59,2.59,0,0,0-2.57,2.59v48.55l33,33.78a2.58,2.58,0,0,0,3.73,0A50.1,50.1,0,0,0,388.62,219C388.62,189.18,366.2,168.34,341,168.4Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.74,265.6H95.46a2,2,0,1,1,0-4H249.74a2,2,0,0,1,0,4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReadoutTest);
export default __webpack_public_path__ + "static/media/Icon_Readout-Test.2a81e26fd30bbab7b2491fa0babba171.svg";
export { ForwardRef as ReactComponent };